import { IVehicleTrack } from "@/types/map";
import distance from "@turf/distance";
import * as turf from "@turf/helpers";
import Pako from "pako";

const worker: Worker = self as any;
let sumoSocket: WebSocket;
let realTimeSocket: WebSocket;

// const vehiclesTracks: Map<string, IVehicleTrack[]> = new Map();

/** 本周期新增车辆 */
let newVehicles: Array<IVehicleTrack> = [];
/** 本周期存量车辆 */
let existVehicles: Array<IVehicleTrack> = [];
/** 行人 */
let persons: Array<IVehicleTrack> = [];
/** 本周期过期车辆id */
let deleteVehicleIds: Array<string> = [];
/** 所有在网车辆id */
let existVehicleIds: Array<string> = [];
/** 每辆车最新数据（位置和接收时间），超时后删除 */
let latestDataMap: Map<
  string,
  { recvTime: number; position: Array<number>; angle: number }
> = new Map();
/**是否间隔发送数据 */
let isFilter: boolean = true;
let lastReceiveDataTime: number = 0;

/** 实时仿真缓存数据，用于坐标平滑 */
let cachedTrackMap: Map<string, Array<IVehicleTrack>> = new Map();
/** 每辆车缓存数据长度 */
const cacheDataLength = 5;
/** sumo消息guid */
let sumoGuid = "";

const angleMap: Map<string, Array<number>> = new Map();

/** 解压 */
const unZip = (key: string) => {
  const charData = [];
  const keyArray = key.split("");
  for (let i = 0; i < keyArray.length; i++) {
    const item = keyArray[i];
    charData.push(item.charCodeAt(0));
  }
  const data = Pako.inflate(charData, { to: "string" });
  return data;
};

const computeAngle = (pos1: Array<number>, pos2: Array<number>) => {
  const x1 = pos1[0];
  const y1 = pos1[1];
  const x2 = pos2[0];
  const y2 = pos2[1];

  if (x1 === x2) {
    return y2 > y1 ? 0 : 180;
  }

  if (y1 === y2) {
    return x2 > x1 ? 90 : 270;
  }

  const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
  let px = 1,
    py = 1;
  if (x2 > x1) {
    px = -1;
  }
  if (y2 > y1) {
    py = -1;
  }
  return ((360 - angle + 90) % 360) - px * py * 5 - 180;
};

// Respond to message from parent thread
worker.addEventListener("message", (event: MessageEvent) => {
  switch (event.data.type) {
    // 连接sumo仿真
    case "connectSumoSimulation": {
      const url = event.data.data.url;
      if (event.data.data.guid) {
        sumoGuid = event.data.data.guid || "";
      }
      sumoSocket = new WebSocket(url);
      // websocket连接打开
      sumoSocket.onopen = () => {
        existVehicleIds = [];
        worker.postMessage({
          type: "sumoSimulationConnectOpen",
        });
        console.log("连接到sumo仿真: " + sumoSocket.url);
      };

      // websocket连接关闭
      sumoSocket.onclose = () => {
        existVehicleIds = [];
        worker.postMessage({
          type: "sumoSimulationConnectClose",
        });
        console.log("sumo仿真断开: " + sumoSocket.url);
      };

      // 接收websocket数据
      sumoSocket.onmessage = (event: MessageEvent) => {
        const data: string = event.data;
        const receivedData = JSON.parse(data);

        if (data.includes("simulate_param")) {
        } else {
          if (sumoGuid === "" || sumoGuid === receivedData.guid) {
            switch (receivedData.pushType) {
              // 车辆位置更新
              case "vehicle_position": {
                if (lastReceiveDataTime == 0) {
                  lastReceiveDataTime = receivedData.time;
                }

                // 大比例尺时，每三秒接受一秒的数据
                const timePassed = receivedData.time - lastReceiveDataTime;
                // if (!isFilter || (isFilter && timePassed <= 3000)) {
                if (true) {
                  const zipTrackList = unZip(receivedData.data);
                  const trackList = JSON.parse(zipTrackList);
                  for (let trackData of trackList) {
                    const {
                      hphm: vehicleId,
                      lng: x,
                      lat: y,
                      simulateTime,
                      speed,
                      angle,
                    } = trackData;
                    const track: IVehicleTrack = {
                      id: vehicleId,
                      time: simulateTime,
                      x,
                      y,
                      speed: Number(speed.toFixed(2)),
                      icon: "car-top-red.png",
                      angle: angle - 180,
                    };

                    // const angles = angleMap.get(vehicleId);
                    // if (angles) {
                    //   angles.push(angle);
                    // } else {
                    //   angleMap.set(vehicleId, [angle]);
                    // }

                    // 判断新增车辆还是在网车辆
                    if (existVehicleIds.includes(vehicleId)) {
                      existVehicles.push(track);
                    } else {
                      newVehicles.push(track);
                      existVehicleIds.push(vehicleId);
                    }
                  }

                  // const angles = [...angleMap.values()];
                  // console.log(angles[0]);

                  worker.postMessage({
                    type: "sumoVehicleUpdated",
                    data: { newVehicles, existVehicles },
                  });
                  newVehicles = [];
                  existVehicles = [];
                }

                if (!isFilter || (isFilter && timePassed > 8000)) {
                  lastReceiveDataTime = receivedData.time;
                }
                break;
              }

              // 车辆退出仿真
              case "vehicle_arrived":
                const vehcleIds = receivedData.data as Array<string>;
                vehcleIds.forEach((vehicleId) => {
                  // 从在网车辆中删除，否则再次经过时无法出现
                  const index = existVehicleIds.indexOf(vehicleId);
                  if (index >= 0) {
                    existVehicleIds.splice(index, 1);
                  }
                });

                worker.postMessage({
                  type: "sumoVehicleDelete",
                  data: vehcleIds,
                });
                break;
            }
          }
        }
      };

      break;
    }

    // 断开sumo仿真
    case "disconnectSumoSimulation":
      sumoSocket.close();
      sumoGuid = "";
      break;

    case "updateSimulationinterval":
      isFilter = event.data.data.zoom < 17;
      break;

    // 连接实时仿真
    case "connectRealTimeSimulation": {
      const url = event.data.data.url;
      realTimeSocket = new WebSocket(url);

      // websocket连接打开
      realTimeSocket.onopen = () => {
        existVehicleIds = [];
        latestDataMap.clear();
        worker.postMessage({
          type: "realTimeSimulationConnectOpen",
        });
        console.log("连接到实时仿真: " + realTimeSocket.url);
      };

      // websocket连接关闭
      realTimeSocket.onclose = () => {
        existVehicleIds = [];
        latestDataMap.clear();
        worker.postMessage({
          type: "realTimeSimulationConnectClose",
        });
        console.log("实时仿真断开: " + realTimeSocket.url);
      };

      // 接收websocket数据
      realTimeSocket.onmessage = (event: MessageEvent) => {
        const receivedData = JSON.parse(event.data);
        // 数据时间
        const dataTimeStamp = new Date(receivedData.jgsj).valueOf();
        // console.log(receivedData.jgsj);
        // 接收时间
        const receiveTimeStamp = new Date().valueOf();

        for (let trackData of receivedData.rtPositionList) {
          const vehicleId: string = trackData.vehNo;

          const vehicleColor: string = trackData.csys || "a";
          let plateColor: string = trackData.hpys || "99";
          // const laneId: number = trackData.dkh;
          let vehicleSize: string = trackData.cx || "small";
          const gpsX: number = trackData.lng;
          const gpsY: number = trackData.lat;
          const angle: number = trackData.angle || 0;
          const showName: string = trackData.showName || "";
          // const transCoord = gcoord.transform(
          //   [gpsX, gpsY],
          //   gcoord.WGS84,
          //   gcoord.GCJ02
          // ) as number[];
          const transCoord = [gpsX, gpsY];

          const latestData = latestDataMap.get(vehicleId);
          if (latestData) {
            const lastPoint = turf.point(latestData.position);
            const thisPoint = turf.point(transCoord);
            const gap = distance(lastPoint, thisPoint, { units: "meters" });
            if (gap < 0.8) {
              latestData.recvTime = receiveTimeStamp;
              continue;
            }
          }

          // 行人单独放一个队列
          if (vehicleId === "88888888" || vehicleId === "99999999") {
            persons.push({
              id: vehicleId,
              time: dataTimeStamp,
              x: transCoord[0],
              y: transCoord[1],
            });
            continue;
          }

          // let cachedData = cachedTrackMap.get(vehicleId);
          // let positionX = 0,
          //   positionY = 0,
          //   angle = 0;
          // if (cachedData) {
          //   cachedData.forEach((track) => {
          //     positionX += track.x;
          //     positionY += track.y;
          //   });
          //   positionX /= cachedData.length;
          //   positionY /= cachedData.length;

          //   angle = computeAngle([positionX, positionY], transCoord);

          //   // if (latestData) {
          //   //   if (
          //   //     latestData.angle !== 0 &&
          //   //     Math.abs(latestData.angle - angle) > 45
          //   //   ) {
          //   //     angle = latestData.angle;
          //   //   }
          //   // }
          // } else {
          //   // 车头默认角度和车道有关
          //   // if (laneId <= 10) {
          //   //   angle = -21;
          //   // } else if (laneId <= 20) {
          //   //   angle = 249;
          //   // } else if (laneId <= 30) {
          //   // } else if (laneId <= 40) {
          //   //   angle = 55;
          //   // }
          // }

          latestDataMap.set(vehicleId, {
            recvTime: receiveTimeStamp,
            position: transCoord,
            angle,
          });

          let color: string;
          let icon: string;
          switch (vehicleColor.toLowerCase()) {
            case "a": // 白
              color = "#ffffff";
              icon = "car-top-white.png";
              break;
            case "b": // 灰
              color = "#9e9e9e";
              icon = "car-top-grey.png";
              break;
            case "c": // 黄
              color = "#ffbb33";
              icon = "car-top-yellow.png";
              break;
            case "d": // 粉
              color = "#e91e63";
              icon = "car-top-pink.png";
              break;
            case "e": // 红
              color = "#f44336";
              icon = "car-top-red.png";
              break;
            case "f": // 紫
              color = "#9c27b0";
              icon = "car-top-purple.png";
              break;
            case "g": // 绿
              color = "#4caf50";
              icon = "car-top-green.png";
              break;
            case "h": // 蓝
              color = "#2196f3";
              icon = "car-top-blue.png";
              break;
            case "i": // 棕
              color = "#795548";
              icon = "car-top-brown.png";
              break;
            case "j": // 黑
              color = "#212121";
              icon = "car-top-black.png";
              break;

            default:
              color = "#ffffff";
              icon = "car-top-white.png";
              break;
          }

          switch (plateColor) {
            case "0":
              plateColor = "#ffffff";
              break;
            case "1":
              plateColor = "#FF8800";
              break;
            case "2":
            case "4":
            case "99":
              plateColor = "#1300EB";
              break;
            case "3":
              plateColor = "#000000";
              break;
            case "15":
            case "16":
              plateColor = "#007E33";
              break;
          }

          switch (vehicleSize) {
            case "1":
              vehicleSize = "small";
              break;
            case "2":
              vehicleSize = "medium";
              break;
            case "3":
              vehicleSize = "large";
              break;
          }

          const track: IVehicleTrack = {
            id: vehicleId,
            time: dataTimeStamp,
            color,
            icon,
            plateColor,
            x: transCoord[0],
            y: transCoord[1],
            angle,
            size: vehicleSize,
            showName,
          };
          if (existVehicleIds.includes(vehicleId)) {
            existVehicles.push(track);
          } else {
            newVehicles.push(track);
            existVehicleIds.push(vehicleId);
          }

          // 缓存数据
          // if (!cachedData) {
          //   cachedData = [track];
          //   cachedTrackMap.set(vehicleId, cachedData);
          // } else {
          //   cachedData.push(track);
          //   if (cachedData.length > cacheDataLength) {
          //     cachedData.shift();
          //   }
          // }
        }

        // 检查已过期的数据
        // const nowTimeStamp = new Date().valueOf();
        // latestDataMap.forEach((latestData, vehicleId) => {
        //   if (nowTimeStamp - latestData.recvTime > 2000) {
        //     deleteVehicleIds.push(vehicleId);
        //     latestDataMap.delete(vehicleId);
        //     cachedTrackMap.delete(vehicleId);

        //     // 从在网车辆中删除，否则再次经过时无法出现
        //     const index = existVehicleIds.indexOf(vehicleId);
        //     if (index >= 0) {
        //       existVehicleIds.splice(index, 1);
        //     }
        //   }
        // });

        worker.postMessage({
          type: "realTimeVehicleUpdated",
          data: {
            newVehicles,
            existVehicles,
            persons,
            deleteVehicles: receivedData.arriveVehList,
            dataTimeStamp,
          },
        });
        newVehicles = [];
        existVehicles = [];
        deleteVehicleIds = [];
        persons = [];
      };
      break;
    }

    // 断开实时仿真
    case "disconnectRealTimeSimulation":
      realTimeSocket.close();
      break;
  }
});

export default worker;
